import AudiofileTranslationResponse from '../../../../../Spirit/Admin/Interfaces/Models/MusicService/AudiofileTranslationResponse';

export default class AudioFileUpdateRequest  {
	Id?: string = '';
	AlbumId: number = 0;
	IsPaid: boolean = false;
	Base64Content?: string = '';
	Translations: Array<AudiofileTranslationResponse> = null;
	constructor(obj?: Partial<AudioFileUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
